import * as React from "react"
import { useTheme } from "../ThemeProvider"
import IconSkeleton from "./IconSkeleton"
import { IconProps } from "./types"

export default function TeamPlanIcon(props: IconProps) {
  const theme = useTheme()

  return (
    <IconSkeleton {...props} iconName="TeamPlanIcon" stroke="none">
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={theme.colors.magenta[20]}
      />
      <path
        d="M12 13.8606C13.0275 13.8606 13.8605 13.0276 13.8605 12.0001C13.8605 10.9726 13.0275 10.1396 12 10.1396C10.9725 10.1396 10.1395 10.9726 10.1395 12.0001C10.1395 13.0276 10.9725 13.8606 12 13.8606Z"
        fill={theme.colors.purple[60]}
      />
      <path
        d="M12 8.74425C12.5137 8.74425 12.9302 8.32777 12.9302 7.81402C12.9302 7.30027 12.5137 6.88379 12 6.88379C11.4862 6.88379 11.0698 7.30027 11.0698 7.81402C11.0698 8.32777 11.4862 8.74425 12 8.74425Z"
        fill={theme.colors.yellow[60]}
      />
      <path
        d="M12 17.1163C12.5137 17.1163 12.9302 16.6998 12.9302 16.1861C12.9302 15.6723 12.5137 15.2559 12 15.2559C11.4862 15.2559 11.0698 15.6723 11.0698 16.1861C11.0698 16.6998 11.4862 17.1163 12 17.1163Z"
        fill={theme.colors.blue[60]}
      />
      <path
        d="M8.51159 12.2326C8.51159 11.7189 8.09511 11.3024 7.58136 11.3024C7.0676 11.3024 6.65112 11.7189 6.65112 12.2326C6.65112 12.7464 7.0676 13.1628 7.58136 13.1628C8.09511 13.1628 8.51159 12.7464 8.51159 12.2326Z"
        fill={theme.colors.teal[70]}
      />
      <path
        d="M16.8837 12.2326C16.8837 11.7189 16.4672 11.3024 15.9534 11.3024C15.4397 11.3024 15.0232 11.7189 15.0232 12.2326C15.0232 12.7464 15.4397 13.1628 15.9534 13.1628C16.4672 13.1628 16.8837 12.7464 16.8837 12.2326Z"
        fill={theme.colors.orange[70]}
      />
    </IconSkeleton>
  )
}
